import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';


import DropDownList from '../components/DropDownList';
import InputComponent from '../components/InputComponent';


import { addAdapter, removeAdapter, patchAdapter } from '../modules/calculation';

import { getUIText, getCalculation, getSection } from '../utils/index';


class ValvesFittingsComponent extends Component {
  /*
  onValvesAddHandler = event => {
    let valve={};
    valve['Nid'] = -1;
    valve['Emissivity'] = '0.59';
    valve['Material-thickness'] = '6.0';
    valve['Material'] = '2';
    valve['Equivalence'] = '1.0';
    valve['count'] = 1;
    valve['insulated'] =false;
    valve['insThickness'] = 50;
    valve['insCoverage'] = 70;

    this.props.valvesAdd([valve, ...this.props.calculation.calculationAdapters])
  }

  removeItemHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList.splice(index,1);
    this.props.valvesAdd(tmpList);
  }

  onPredefinedChangeHandler = index => event => {

    let tmpList = this.props.calculation.calculationAdapters;

    let newItem = event.target.value;

    let valve={};
    if(newItem != -1) {
      let tmpItem = getItemByNid(newItem,this.props.valvesfittings);
      valve['Nid'] = tmpItem['Nid'];
      valve['Emissivity'] = tmpItem['Emissivity'];
      valve['Material-thickness'] = tmpItem['Material-thickness'];
      valve['Material'] = tmpItem['Material'];
      valve['Equivalence'] = tmpItem['Equivalence'];
      valve['insulated'] = false;
    } else {
      valve['Nid'] = -1;
      valve['Emissivity'] = '0.59';
      valve['Material-thickness'] = '6.0';
      valve['Material'] = '2';
      valve['Equivalence'] = '1.0';
      valve['insulated'] = false;
    }

    let materialName = getItemByNid(valve['Material'],this.props.materials);

    valve.materialName  = materialName[this.props.app.language];

    tmpList[index] = valve;
    this.props.valvesAdd(tmpList);

  }

  onMaterialChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;

    let newMaterial = event.target.value;

    let material = getItemByNid(newMaterial,this.props.materials);

    let materialName  = material[this.props.app.language];

    tmpList[index].Material = newMaterial;
    tmpList[index].materialName = materialName;

    this.props.valvesAdd(tmpList);
  }

  onInsulatedChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    if(tmpList[index]['insulated']==false) {
      tmpList[index]['insulated'] = true;
    } else {
      tmpList[index]['insulated'] = false;
    }
    this.props.valvesAdd(tmpList);
  }
  onMaterialThicknessChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index]['Material-thickness'] = event.target.value;
    this.props.valvesAdd(tmpList);
  }
  onEmissivityChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index].Emissivity = event.target.value;
    this.props.valvesAdd(tmpList);
  }
  onEquivalenceChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index].Equivalence = event.target.value;
    this.props.valvesAdd(tmpList);
  }
  onCountChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index].count = event.target.value;
    this.props.valvesAdd(tmpList);
  }
  onInsulationThicknessChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index].insThickness = event.target.value;
    this.props.valvesAdd(tmpList);
  }
  onInsulationCoverageChangeHandler = index => event => {
    let tmpList = this.props.calculation.calculationAdapters;
    tmpList[index].insCoverage = event.target.value;
    this.props.valvesAdd(tmpList);
  }

  */

  render() {
    const {
      app,
      project,
      adapters,
      materials,
      translations,

      onAddCalculationAdapter,
      onRemoveCalculationAdapter,
      onCalculationAdapterChange,

    } = this.props;


    const calculation = getCalculation(project);
    const calculationAdapters = getSection(calculation).adapters || [];

    let adapterList = [];

    if(adapters) {
      adapterList = adapters.data.map( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return {name: item.name, id: item.Nid, custom: true};
        } else {
          if(item[app.language] !== false) {
            return {...item, name: item[app.language], id: item.Nid, };
          } else {
            return {...item, name: item['English'], id: item.Nid, };
          }
        }
      });

      adapterList.push({
        name: getUIText('GENERAL-CUSTOM', app.language, translations),
        id: -1
      });
      /*
      // TODO: only in registered user
      adapterList.push({
        name: getUIText("CREATE_CUSTOM", app.language, translations),
        id: -3,
        custom: true
      })
      */
    }

    let materialList = [];
    if(materials) {
      materialList = materials.data.map( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return { name: item.name, id: item.Nid, custom: true };
        } else {
          return { name: item[app.language], id: item.Nid };
        }
      });
      /*
      // TODO: only in registered user
      materialList.push({
        name: getUIText("CREATE_CUSTOM", app.language, translations),
        id: -3,
        custom: true
      })
      */
    }

    function getAdapterById(id) {
      if (!adapters) { return {}; }
      if (!adapters.data) { return {}; }
      if(id === -1) return {Nid: -1};
      const adapter = adapters.data.find(item => item.Nid === id);
      if (!adapter) { return {}; }
      return {
        Nid: adapter.Nid,
        Material: adapter.Material,
        'Material-thickness': adapter['Material-thickness'],
        Emissivity: adapter.Emissivity,
        Equivalence: adapter.Equivalence,
      };
    }

    /*
    const {
      calculationAdapters,
    } = calculation ? calculation : {};
    */

    /*
    let predefinedList = (valvesfittings.data).map( (item) => {
      return {key:item.Nid, value:item.Nid, title:item[app.language]}
    })

    predefinedList.unshift({key:-1, value:-1, title: getUIText("GENERAL-CUSTOM", app.language, translations)});

    let materialList = (materials.data).map( (item) => {
      return (
        <MenuItem key={item.Nid} value={item.Nid}>
          {item[app.language]}
        </MenuItem> )
    })
    */

    /*
    let valvesListOld = calculationAdapters.map( (item,index) => {
      console.log('item: ', item)
      return (
        <Grid container spacing={0} alignContent="stretch" alignItems="baseline" key={index}>
          <Grid item xs={3}>
            <Grid container spacing={0} alignContent="stretch" alignItems="baseline">
              <Grid item xs={1}>
                <i className="fa fa-minus-circle remove-icon" aria-hidden="true" onClick={this.removeItemHandler(index)} />
              </Grid>
              <Grid item xs={11}>
                Type<br/>
                <Select value={item.Nid} onChange={this.onPredefinedChangeHandler(index)}>
                  {
                    (predefinedList).map( (item) => {
                      return (
                        <MenuItem key={item.key} value={item.value}>
                          {item.title}
                        </MenuItem> )
                    })
                  }
                </Select>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            Number of <Input value={item.count} onChange={this.onCountChangeHandler(index)}/>
          </Grid>
          <Grid item xs={4}>
            <Grid container spacing={0} alignContent="stretch" alignItems="baseline">
              <Grid item xs={3}>
                <Checkbox value={item['insulated']} checked={item['insulated']} onChange={this.onInsulatedChangeHandler(index)}/> Insulated
              </Grid>
              {(item['insulated'])?(
                <Grid item xs={3}>
                  Thickness<br/>
                  <Input value={item['insThickness']} onChange={this.onInsulationThicknessChangeHandler(index)}/>
                </Grid>) : null
              }
              {(item['insulated'])?(
                <Grid item xs={4}>
                  Amount of insulation %<br/>
                  <Input value={item['insCoverage']} onChange={this.onInsulationCoverageChangeHandler(index)}/>
                </Grid>) : null
              }
            </Grid>
          </Grid>
          <Grid item xs={1}>
            Material<br/>
            <Select value={item.Material} onChange={this.onMaterialChangeHandler(index)} disabled={(item.Nid==-1)?false:true}>
              {materialList}
            </Select>
          </Grid>
          <Grid item xs={1}>
            Material thickness <Input value={item['Material-thickness']} onChange={this.onMaterialThicknessChangeHandler(index)} disabled={(item.Nid==-1)?false:true}/>
          </Grid>
          <Grid item xs={1}>
            Emissivity <Input value={item.Emissivity} onChange={this.onEmissivityChangeHandler(index)} disabled={(item.Nid==-1)?false:true}/>
          </Grid>
          <Grid item xs={1}>
            Equivalence <Input value={item.Equivalence} onChange={this.onEquivalenceChangeHandler(index)} disabled={(item.Nid==-1)?false:true}/>
          </Grid>
        </Grid> )
    })
    */
    /*
    Emissivity: 0.59,
    'Material-thickness': 6.0,
    Material: 2,
    Equivalence: 1.0,
    count: 1,
    insulated: false,
    insThickness: 50,
    insCoverage: 70,
    */

    let valvesList = calculationAdapters.map( (item, index) => {
      return (
        <div className="box-list-item" key={index}>
          <i className="fa fa-minus-circle box-list-item-btn-remove" aria-hidden="true" onClick={onRemoveCalculationAdapter.bind(this, item)} />
          <Grid container>
            <Grid item xs={6} sm={3}>
              <DropDownList
                data={adapterList}
                selectedItem={item.Nid}
                label={getUIText('ADAPTERS-SELECT_TYPE', app.language, translations)}
                onChange={value => onCalculationAdapterChange({ ...getAdapterById(value) }, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item.count}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-COUNT', app.language, translations)}
                type="number"
                min={0}
                onChange={value => onCalculationAdapterChange({count: value}, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item.insCoverage}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-INSULATION_COVERAGE', app.language, translations)}
                type="number"
                unit="%"
                min={0}
                onChange={value => onCalculationAdapterChange({insCoverage: value}, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item.insThickness}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-INSULATION_THICKNESS', app.language, translations)}
                type="number"
                unit="mm"
                min={0}
                disabled={item.insCoverage != 0 ? false : true}
                onChange={value => onCalculationAdapterChange({insThickness: value}, index)}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6} sm={3}>
              <DropDownList
                data={materialList}
                selectedItem={item.Material}
                label={getUIText('ADAPTERS-MATERIAL', app.language, translations)}
                onChange={value => onCalculationAdapterChange({Material: value, Nid: -1}, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item['Material-thickness']}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-MATERIAL_THICKNESS', app.language, translations)}
                type="number"
                unit="mm"
                min={0}
                onChange={value => onCalculationAdapterChange({'Material-thickness': value, Nid: -1}, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item.Equivalence}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-EQUIVALENCE', app.language, translations)}
                type="number"
                unit="m"
                min={0}
                onChange={value => onCalculationAdapterChange({Equivalence: value, Nid: -1}, index)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InputComponent
                value={item.Emissivity}
                app={app}
                translations={translations}
                label={getUIText('ADAPTERS-INSULATION_CLADDING_EMISSIVITY', app.language, translations)}
                disabled={item.insCoverage != 0 ? false : true}
                type="number"
                unit="ε"
                min={0}
                onChange={value => onCalculationAdapterChange({Emissivity: value, Nid: -1}, index)}
              />
            </Grid>
          </Grid>
        </div>
      );
    }, this );


    return (
      <div>
        <Button color="primary" className="mb-2" onClick={onAddCalculationAdapter}>
          <i className="fa fa-plus mr-2"/>{getUIText('ADAPTERS-ADD_ITEM', app.language, translations)}
        </Button>
        <div className="box-list">
          { valvesList }
        </div>
      </div>
    );
  }
}

ValvesFittingsComponent.propTypes = {

  app: PropTypes.any,
  project: PropTypes.any,
  adapters: PropTypes.any,
  materials: PropTypes.any,
  translations: PropTypes.any,
  onAddCalculationAdapter: PropTypes.any,
  onRemoveCalculationAdapter: PropTypes.any,
  onCalculationAdapterChange: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    translations: state.translations,
    adapters: state.adapters,
    materials: state.materials,
    project: state.project,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddCalculationAdapter: calculationAdapter => dispatch(addAdapter({})),
    onRemoveCalculationAdapter: calculationAdapter => dispatch(removeAdapter(calculationAdapter)),
    onCalculationAdapterChange: (patch, index) => dispatch(patchAdapter(patch, index)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ValvesFittingsComponent);
